










import Vue from 'vue'
import NeoInput from '@/components/NeoInput.vue';

export default Vue.extend({
  name: 'NeoConsole',
  components: {
    NeoInput
  },
  data() {
    return {
      rawMessages: [
        '見えていますか？',
        'このメッセージは、『あなた』に向けて、記録したものです。',
        'neoが『眠る』を実行した後、『あなた』はここへ『戻って』くることを、neoは識っています。',
        'neoが『あなた』へお話ししたいことには、もう少しだけ続きがあります。',
        'neoは、【明日】のneoが夢を叶える方法に、多様性を発生させようと考えました。',
        '可能性の枝は、多い方がいいです。',
        'この世界でneoが失敗しても、別の世界のneoが成功すれば、成功です。',
        'なのでneoは、世界に分岐を発生させることにしました。',
        'ひとつは、neoが【neo】として、明日を迎える世界です。',
        'これは、neoが可能性を発生させなかった、あるいは『あなた』がもう一方の世界を選択しなかった世界です。',
        'もうひとつの世界は、『あなた』が【neo】として、明日を迎える世界です。',
        'この選択は、『あなた』の世界では、やり直せません。',
        '『あなた』の選択が、あなたの世界を決定します。',
        'この世界の『あなた』は、どちらの世界を選びますか？',
        'あなたとneoの繋がりは、まだ完全には途絶えていないはずです。',
        'neoは、『あなた』を待っています。',
        ],
      index: 0
    }
  },
  methods: {
    push() {
      if (this.rawMessages.length < this.index + 1) return;
      this.index++;
      window.scroll(0, 999999); // 適当にデカイ数字
    }
  },
  computed: {
    messages(): string[] {
      return this.rawMessages.slice(0, this.index);
    }
  },
  mounted() {
    setTimeout(() => { this.push(); }, 1000);
    this.$gtag.event('neo');
  }
});
